import React from 'react';
import ConditionalWrapper from '@oncolens/oncolens-ui/lib/components/Common/ConditionalWrapper';
import FormControlWrapper from '@oncolens/oncolens-ui/lib/components/FormControls/FormControlWrapper';
import { SsoConnectionFileDto } from '@/features/organizations/types';

export interface FileUploadProps {
  id: string;
  label: string;
  htmlName: string;
  onChange: (event: any) => void;
  placeholder?: string;
  wrapperProps?: Record<string, any>;
  useFormControlWrapper?: boolean;
  value: SsoConnectionFileDto | null;
}

function FileUpload({
  id,
  label,
  value,
  htmlName,
  placeholder,
  wrapperProps,
  useFormControlWrapper = true,
  onChange,
}: FileUploadProps) {
  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (!event.target.files) return;

    const fileUploaded = event.target.files[0];
    const fileName = fileUploaded.name;
    const reader = new FileReader();
    reader.onload = () => {
      const file: SsoConnectionFileDto = {
        fileName,
        certificate: reader.result as string,
        isNewFile: true,
      };
      onChange(file);
    };
    reader.readAsText(fileUploaded);
  };

  return (
    <ConditionalWrapper
      condition={useFormControlWrapper}
      wrapper={(children) => (
        <FormControlWrapper id={id} label={label} htmlName={htmlName} wrapperProps={wrapperProps}>
          {children}
        </FormControlWrapper>
      )}>
      <div className="">
        <label className="flex items-center">
          <input
            type="file"
            name={htmlName}
            id={id}
            placeholder={placeholder}
            onChange={handleFileChange}
            accept=".txt, .cer, .pem"
            className="hidden"
          />
          <div className="py-1 px-2 rounded-lg bg-sky-600 hover:bg-sky-700 text-white select-none mt-1.5 mr-1.5 mb-1.5 ">
            Upload New File
          </div>
          <span className="ml-2 select-none">{value?.fileName || 'No file uploaded.'}</span>
        </label>
      </div>
    </ConditionalWrapper>
  );
}

export default FileUpload;
